// Language Switcher for the Footer
import React, { Fragment, useContext, useCallback } from 'react';
import classnames from 'classnames';

import { resizeModule } from '@shcc/modules/ResizeModule';

// Helpers
import { LANGUAGES } from '@helpers/languages';

// Context
import i18nContext from '@components/i18n/i18nContext';

// Styles
import styles from './SwitchLanguageComponent.module.scss';

// Assets
import Icon from './assets/icon.svg';
import IconWhite from './assets/icon-white.svg';

const SwitchLanguageComponent = ({ className, isWhite }) => {
  const { lng, languageUrls } = useContext(i18nContext);

  const handleChangeLng = newLng => {
    if (typeof window !== `undefined`) {
      const path = window.location.pathname.replace(
        LANGUAGES[lng].prefix + '/',
        '/'
      ); // remove old prefix from path
      window.location.href =
        window.location.origin + LANGUAGES[newLng].prefix + path; // add selected prefix to path
    }
  };

  return (
    <div
      className={classnames(
        styles.wrap,
        { [styles.isWhite]: isWhite },
        className
      )}
    >
      <select
        className={styles.select}
        defaultValue={lng}
        onChange={e => {
          e.target.value !== lng ? handleChangeLng(e.target.value) : null;

          try {
            setTimeout(() => resizeModule.forceUpdate(), 250);
          } catch (err) {
            console.log(err);
          }
        }}
      >
        {Object.keys(LANGUAGES).map(langcode =>
          LANGUAGES[langcode].languageSwitcher ? (
            <option key={langcode} value={langcode}>
              {LANGUAGES[langcode].label}
            </option>
          ) : null
        )}
        ;
      </select>
      <img className={styles.icon} src={isWhite ? IconWhite : Icon} alt="" />
    </div>
  );
};

export default SwitchLanguageComponent;
